<template>
  <div class="pointList">
    <div class="intes-bt">
      <div class="intes-bt-img">
        <img :src="require(`@/assets/image/anxin/fen.png`)" />
      </div>
      <div class="intes-bt-test">
        <div
          :style="{
            color:
              marks <= 60
                ? '#D45353'
                : marks >= 61 && marks <= 74
                ? '#f1be33'
                : marks >= 75 && marks <= 84
                ? '#9ef133'
                : '#28d200',
          }"
        >
          <b
            ><NumberGrow
              :value="marks"
              :fontSize="'0.96rem'"
              :fontWeight="'bolder'"
            ></NumberGrow></b
          >分
        </div>
        <p>您的健康总分</p>
      </div>
      <div class="intes-bt-fs" @click="handClickFs">分数说明</div>
    </div>
    <div class="intes-bt-box">
      <div class="intes-bt-box-tit">异常指标</div>
      <noZklist :list="list" v-show="list.length !== 0"></noZklist>
      <div v-show="list.length == 0" style="text-align: center">暂无数据</div>
      <div class="intes-bt-box-tit mt20">身体状况</div>
      <van-cell
        :value="st.value + '分'"
        is-link
        class="mytab mytabTT"
        center
        @click="handClickLink(st)"
      >
        <!-- 使用 title 插槽来自定义标题 -->
        <template #title>
          <div class="pointImgcomment1">
            <img :src="require(`@/assets/image/anxin/身体状况详情.png`)" />
            <div>
              <span class="span1"> 身体状况详情 </span>
              <b
                :style="{
                  color:
                    st.status == '差'
                      ? '#D45353'
                      : st.status == '中'
                      ? '#F1BE33'
                      : st.status == '良'
                      ? '#9EF133'
                      : '#28D200',
                }"
              >
                ({{ st.status }})
              </b>
              <br />
              <span class="span2"> <i v-text="st.gs"> </i>项异常 </span>
            </div>
          </div>
        </template>
      </van-cell>
      <div class="intes-bt-box-tit mt20">趋势分析</div>
      <div class="mytab zxtjt">
        <div class="zxtjtr">检测总分趋势分析</div>
        <echarts-bar :barlist="qsfx"></echarts-bar>
      </div>
      <div class="tswz">
        该分析为功能评估，结果不作为临床诊断标准，如需诊断是否患有疾病，请到专业医疗机构进行诊断检查。
      </div>
    </div>
  </div>
</template>
<script>
import markbox from "./markBox.vue"
import noZklist from "./noZklist.vue"
import EchartsBar from './EchartsBar'
import NumberGrow from "./NumberGrow.vue"
export default {
  props: ['list', 'marks', 'st', 'qsfx'],
  components: {
    markbox, EchartsBar, noZklist, NumberGrow
  },
  data () {
    return {
      activeNames: [],

    }
  },
  watch: {
    list (newVal) {
      this.list = newVal;
    }
  },
  methods: {

    handClickFs () {
      this.$emit('fatherMethod');
    },
    handClickLink (item) {
      this.$router.push({ path: '/peaceConditionOld', query: { row: encodeURIComponent(JSON.stringify(item)) } });
    }
  }
}
</script>
<style lang="scss" scoped>
.mytab {
  box-shadow: 0px 10px 29px 0px rgba(91, 145, 190, 0.1);
  border-radius: 10px;
  overflow: hidden;
}

.intes-bt {
  height: 250px;
  .intes-bt-img {
    position: absolute;
    width: 280px;
    height: 291px;
    left: 50%;
    top: 0;
    margin-left: -140px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .intes-bt-test {
    position: absolute;
    width: 280px;
    height: 291px;
    left: 50%;
    top: 0;
    margin-left: -135px;
    padding-top: 60px;
    text-align: center;
    font-size: 30px;
    font-weight: bold;
    b {
      font-size: 72px;
      font-weight: bolder;
    }
    p {
      font-size: 20px;
      margin: 0;
      color: #999;
      letter-spacing: 0;
      font-weight: 400;
      margin-top: -5px;
    }
  }
  .intes-bt-fs {
    position: absolute;
    right: 27px;
    top: 10px;
    text-decoration: underline;
    font-size: 28px;
    color: #fff;
  }
}
.intes-bt-box {
  padding: 0 30px;
  .intes-bt-box-tit {
    font-size: 28px;
    color: #fff;
    margin-bottom: 16px;
  }
  .mt20 {
    margin-top: 30px;
    font-size: 24px;
    color: #666;
  }
  .tswz {
    font-size: 20px;
    color: #666;
    margin: 30px 0;
    line-height: 30px;
  }
  .zxtjt {
    background: #fff;
    height: 450px;
  }
  .zxtjtr {
    font-size: 20px;
    margin: 30px 0 0 30px;
    color: #8c8c8c;
  }

  .pointImgcomment1 {
    display: flex;
    img {
      width: 65px;
      height: 65px;
      vertical-align: middle;
      margin-right: 20px;
    }
    .span1 {
      font-size: 26px;
      vertical-align: middle;
      display: inline-block;
    }
    b {
      font-weight: 400;
      font-size: 26px;
    }
    div {
      flex: 1;
    }
    .span2 {
      font-size: 22px;
      display: inline-block;
      margin-top: 10px;
      i {
        color: #d45353;
        margin-right: 5px;
      }
    }
  }
}
</style>